export enum ServicesValuesTypes {
  RESERVATIONS = 'RESERVATIONS',
  SUBSCRIPTIONS = 'SUBSCRIPTIONS',
  EV_CHARGERS = 'EV_CHARGERS',
  AUTOPAY = 'AUTOPAY',
  NAVIPAY = 'NAVIPAY',
  PARK_AND_FLY = 'PARK_AND_FLY',
  SCOOTERS = 'SCOOTERS',
  VALET = 'VALET',
  CAR_WASH = 'CAR_WASH',
  AIRPORT_TRANSFER = 'PARK_AND_FLY_AIRPORT_TRANSFER',
  CAR_SEAT = 'PARK_AND_FLY_CAR_SEAT',
  KEY_STORAGE = 'PARK_AND_FLY_KEY_STORAGE',
  SAFE = 'PARK_AND_FLY_SAFE'
}

export type ServiceOptionsTypes = {
  value: ServicesValuesTypes
  title: string
}

export type ServicesProps = {
  handleAddRemoveService: (service: ServicesValuesTypes) => void
  selectedServices: ServicesValuesTypes[]
  servicesOptions: ServiceOptionsTypes[]
  title: string
}
